import React from 'react';
import { TablePagination, Box, Pagination, Typography, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { isMobile, isDesktop, isTablet, BrowserView, MobileView } from 'react-device-detect';
interface CustomPaginationProps<T> {
    page: number;
    data: T[];
    rowsPerPage: number;
    onChangePage: (
        event: React.MouseEvent<HTMLButtonElement> | React.ChangeEvent<unknown> | null,
        newPage: number
    ) => void;
    onChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<number>) => void;
}

// const CustomPagination = <T,>({
//     data,
//     page,
//     rowsPerPage,
//     onChangePage,
//     onChangeRowsPerPage
// }: CustomPaginationProps<T>) => {
//     return (
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//             {/* Bên trái: chọn số dòng mỗi trang */}
//             <Box>
//                 <TablePagination
//                     rowsPerPageOptions={[10, 20, 50, 100]}
//                     component="div"
//                     count={data.length}
//                     rowsPerPage={rowsPerPage}
//                     page={page}
//                     onPageChange={() => {}} // không xử lý đổi trang ở đây
//                     onRowsPerPageChange={onChangeRowsPerPage}
//                     labelRowsPerPage="Số dòng mỗi trang"
//                     labelDisplayedRows={() => ''} // ẩn hiển thị số trang
//                     ActionsComponent={() => null} // ẩn nút phân trang trái
//                 />
//             </Box>
//             <Box>
//                 <TablePagination
//                     rowsPerPageOptions={[]} // ẩn combo chọn số dòng
//                     component="div"
//                     count={data.length}
//                     rowsPerPage={rowsPerPage}
//                     page={page}
//                     onPageChange={onChangePage}
//                     onRowsPerPageChange={() => {}} // không xử lý ở đây
//                     labelDisplayedRows={({ from, to, count }) =>
//                         `Hiển thị ${from} – ${to} mục của ${count !== -1 ? count : `nhiều hơn ${to}`}`
//                     }
//                 />
//             </Box>
//         </Box>
//     );
// };

const CustomPagination = <T,>({
    data,
    page,
    rowsPerPage,
    onChangePage,
    onChangeRowsPerPage
}: CustomPaginationProps<T>) => {
    const totalCount = data.length;
    const totalPages = Math.ceil(totalCount / rowsPerPage);
    const from = page * rowsPerPage + 1;
    const to = Math.min((page + 1) * rowsPerPage, totalCount);
    const handleChangeRowsPerPage = (event: SelectChangeEvent<number>) => {
        onChangeRowsPerPage(event);
    };
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} px={2} py={1}>
            {/* Trái: combo số dòng mỗi trang */}
            <Box display="flex" alignItems="center">
                <Typography variant="body2" mr={1}>
                    Số dòng mỗi trang:
                </Typography>
                <Select size="small" value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                    {[5, 10, 15, 20, 25, 50, 100].map((option) => (
                        <MenuItem key={option} value={option}>
                            {option} / trang
                        </MenuItem>
                    ))}
                </Select>
            </Box>

            {/* Phải: hiển thị số trang + thông tin */}
            <Box display="flex" alignItems="center" gap={2}>
                <Typography variant="body2">
                    Hiển thị {from} - {to} của {totalCount} mục
                </Typography>
                <Pagination
                    count={totalPages}
                    page={page + 1}
                    onChange={(event, value) => onChangePage(event, value - 1)}
                    sx={{
                        '& .MuiPaginationItem-root': {
                            color: '#000000', // Màu chữ
                            margin: '0 1px',
                            '&:hover': {
                                color: '#ffffff', // Màu chữ khi hover
                                backgroundColor: 'var(--main-color)'
                            },
                            '&.Mui-selected': {
                                backgroundColor: 'var(--main-color)',
                                color: '#ffffff',
                                '&:hover': {
                                    backgroundColor: 'var(--main-color)'
                                }
                            }
                        },
                        '& .Mui-selected': {
                            backgroundColor: 'var(--main-color)',
                            color: '#ffffff',
                            '&:hover': {
                                backgroundColor: 'var(--main-color)'
                            }
                        }
                    }}
                    shape="rounded"
                    size="medium"
                    siblingCount={1}
                    boundaryCount={1}
                />
            </Box>
        </Box>
    );
};

export default CustomPagination;
